import React, { useEffect, useRef, useState } from "react";

const ExcelUploadField = ({
  label = "Cartera Mes actual",
  onFileChange,
  disabled = false,
  accept,
  buttonText = "Seleccionar archivo",
  emptyText = "Sin archivo seleccionado",
  helperText = "Formatos permitidos: Excel .xlsx",
  validateFile,
  selectedFileName,
  allowClear = true,
  hideLabel = false
}) => {
  const inputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState("");

  const defaultAccept =
    ".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel";
  const currentAccept = accept || defaultAccept;
  const isControlledName = selectedFileName !== undefined;
  const displayFileName = isControlledName ? selectedFileName : fileName;

  useEffect(() => {
    if (!isControlledName && !selectedFileName) {
      setFileName("");
    }
  }, [isControlledName, selectedFileName]);

  const validateExcelFile = (file) => {
    const name = file?.name?.toLowerCase?.() || "";
    const isExcel = name.endsWith(".xlsx") || name.endsWith(".xls");

    if (!isExcel) {
      return "El archivo debe ser Excel (.xlsx o .xls).";
    }

    return "";
  };

  const openPicker = () => {
    if (!disabled) inputRef.current?.click();
  };

  const clearFile = () => {
    if (!isControlledName) {
      setFileName("");
    }
    setError("");
    if (inputRef.current) inputRef.current.value = "";
    onFileChange?.(null);
  };

  const handleChange = (e) => {
    const file = e.target?.files?.[0];
    if (!file) return;

    const validationError = validateFile
      ? validateFile(file)
      : validateExcelFile(file);

    if (validationError) {
      setError(validationError);
      if (!isControlledName) {
        setFileName("");
      }
      if (inputRef.current) inputRef.current.value = "";
      onFileChange?.(null);
      return;
    }

    setError("");
    if (!isControlledName) {
      setFileName(file.name);
    }
    onFileChange?.(file);
  };

  return (
    <div style={styles.wrapper}>
      <div style={hideLabel ? styles.rowWithoutLabel : styles.row}>
        {hideLabel ? null : <div style={styles.label}>{label}</div>}

        <div style={styles.fileGroup}>
          <button
            type="button"
            onClick={openPicker}
            disabled={disabled}
            style={{
              ...styles.button,
              ...(disabled ? styles.buttonDisabled : null)
            }}
          >
            {buttonText}
          </button>

          <div
            style={styles.filenameBox}
            title={displayFileName || emptyText}
          >
            {displayFileName || emptyText}
          </div>

          {!disabled && allowClear && displayFileName && (
            <button
              type="button"
              onClick={clearFile}
              style={styles.clearBtn}
              title="Quitar archivo"
            >
              ×
            </button>
          )}

          <input
            ref={inputRef}
            type="file"
            accept={currentAccept}
            onChange={handleChange}
            disabled={disabled}
            style={{ display: "none" }}
          />
        </div>
      </div>

      {helperText ? (
        <div style={hideLabel ? styles.helperWithoutLabel : styles.helper}>
          {helperText}
        </div>
      ) : null}

      {error && (
        <div style={hideLabel ? styles.errorWithoutLabel : styles.error}>
          {error}
        </div>
      )}
    </div>
  );
};

const styles = {
  wrapper: {
    width: "100%"
  },
  row: {
    display: "grid",
    gridTemplateColumns: "140px 1fr",
    gap: "16px",
    alignItems: "center"
  },
  rowWithoutLabel: {
    display: "block"
  },
  label: {
    fontSize: "13px",
    color: "#2b2b2b"
  },
  fileGroup: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%"
  },
  button: {
    height: "34px",
    padding: "0 12px",
    borderRadius: "4px",
    border: "1px solid #c7c7c7",
    background: "#f7f7f7",
    cursor: "pointer",
    fontSize: "13px",
    whiteSpace: "nowrap"
  },
  buttonDisabled: {
    opacity: 0.6,
    cursor: "not-allowed"
  },
  filenameBox: {
    height: "34px",
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
    border: "1px solid #c7c7c7",
    borderRadius: "4px",
    background: "#ffffff",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "13px",
    color: "#3b3b3b"
  },
  clearBtn: {
    height: "34px",
    width: "34px",
    borderRadius: "4px",
    border: "1px solid #c7c7c7",
    background: "#ffffff",
    cursor: "pointer",
    fontSize: "18px",
    lineHeight: "18px"
  },
  helper: {
    marginTop: "6px",
    fontSize: "12px",
    color: "#6b6b6b",
    paddingLeft: "156px"
  },
  helperWithoutLabel: {
    marginTop: "6px",
    fontSize: "12px",
    color: "#6b6b6b"
  },
  error: {
    marginTop: "6px",
    fontSize: "12px",
    color: "#c62828",
    paddingLeft: "156px"
  },
  errorWithoutLabel: {
    marginTop: "6px",
    fontSize: "12px",
    color: "#c62828"
  }
};

export default ExcelUploadField;
